import axios from 'axios'
import { ElMessage,ElLoading } from 'element-plus'
import store from '@/store'
import router from '../router'
import { getSessionStorage } from './auth'
// 当前接口请求数
let requestNum = 0;
let loadingInstance = null;
// create an axios instance https://filmer.mozihealthcare.com.cn:8089  http://192.168.1.127:8080/
const service = axios.create({
  //baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.6.13:8079/' : '', // api 的 base_url
  baseURL: '',
  timeout: 5000 * 10 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      background: "rgba(0, 0, 0, 0.1)",
      text: "加载中...",
    });
    requestNum += 1;
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      // config.headers['X-Token'] = getToken()
    }
    // const urlParams = {
    //   stGrpNo: '02909686',
    //   stChkTime: '2020-12-21 15:16:20'
    // }
    const urlParams = getSessionStorage('urlParams')
    config.params = Object.assign(config.params, urlParams)
    config.data = Object.assign(config.data, urlParams)
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  //   response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    requestNum = requestNum - 1;
    if (requestNum <= 0) {
      loadingInstance.close();
    }
    const res = response.data
    if (!res.success) {
      ElMessage({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // 请自行在引入 MessageBox
        // import { Message, MessageBox } from 'element-ui'
        // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        //     location.reload() // 为了重新实例化vue-router对象 避免bug
        //   })
        // })
      }
      return
    } else {
      return response.data
    }
  },
  error => {
    // console.log('err' + error) // for debug
    // ElMessage({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // router.push({
    //   path: '/home',
    //   replace: true
    // })
    loadingInstance.close();
    return Promise.reject(error)
  }
)

export default service
